import { ContainerInfo, InfoLabel, InfoSpanDescription } from './styles';

export const InfoDescription = ({ label, description }) => (
  <ContainerInfo>
    <InfoLabel>{label}</InfoLabel>
    {description && <InfoSpanDescription>{description}</InfoSpanDescription>}
  </ContainerInfo>
);
